<template src="./Listas.html"></template>

<script>
import { urlTemplate } from "../../apiService/request/crudMendajes";
import { updateList } from "../../apiService/request/CrudListas";
export default {
  data() {
    return {
      itemList: [
        { valor: "Documento" },
        { valor: "Imagen" },
        { valor: "Video" },
        { valor: "Audio" },
      ],
      listSelected: "",
      listData: [],
      edit: [],
      containerButtons: 0,
      arrayDeleted: [],
      disabledbtnDeleted: false,
      newTitle: "",
      newUrl: "",
      newOpcion: false,
      keyList: "",
      myRules: [(v) => !!v || "¡El campo no puede estar vacío!"],
      disabledBtnSave: true,
      btnAddNewOption: false,
    };
  },
  computed: {
    btnAddDisabled() {
      if (this.newTitle === "" || this.newUrl === "") {
        return true;
      }
      return false;
    },
  },
  methods: {
    addNewopcion() {
      this.newOpcion = true;
      this.edit = [];
    },
    saveAddNewList() {
      this.$store.dispatch("setCargando", true);
      try {
        const NEWDATALIST = {
          valor: this.newTitle,
          puntaje: null,
          nombre: this.newUrl,
        };
        this.listData.push(NEWDATALIST);
        this.cancelAdd();
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
        this.disabledBtnSave = false;
      }
    },
    async saveNewList() {
      this.$store.dispatch("setCargando", true);
      let response = confirm(
        "¿Está seguro de guardar los cambios realizados a la lista?"
      );
      try {
        if (response) {
          const RESPONSE = await updateList(
            this.keyList,
            this.$store.state.provider_email,
            this.listData
          );
          if (RESPONSE && RESPONSE.data && RESPONSE.data.data) {
            window.alert(RESPONSE.data.message);
            this.disabledBtnSave = true;
          }
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.getList();
        this.$store.dispatch("setCargando", false);
      }
    },
    deleteItemList(i) {
      this.edit = [];
      let response = confirm("¿Está seguro de eliminar esta opción?");
      if (response) {
        if (this.listData.length > 1) {
          this.listData.splice(i, 1);
        } else {
          alert("La lista debe tener mínimo una opción");
          this.disabledbtnDeleted = true;
        }
        this.disabledBtnSave = false;
      }
    },
    changeListData(i, type, text) {
      if (text === "") {
        this.disabledBtnSave = true;
        this.btnAddNewOption = true;
      } else {
        this.disabledBtnSave = false;
        this.btnAddNewOption = false;
      }
      this.listData[i][type] = text;
    },
    cancelAdd() {
      this.btnAddNewOption = false;
      this.newOpcion = false;
      this.newTitle = "";
      this.newUrl = "";
    },
    cancel() {
      this.listSelected = "";
      this.listData = [];
      this.edit = [];
      this.containerButtons = 0;
      this.arrayDeleted = [];
      this.disabledbtnDeleted = true;
      this.cancelAdd();
    },
    editContent(i) {
      this.edit = [];
      this.edit[i] = true;
    },
    async getList() {
      this.listData = [];
      this.edit = [];
      this.containerButtons = 0;
      this.arrayDeleted = [];
      this.disabledbtnDeleted = true;
      this.disabledBtnSave = true;

      this.cancelAdd();
      this.$store.dispatch("setCargando", true);
      try {
        const RESPONSE = await urlTemplate(this.listSelected);
        if (
          RESPONSE &&
          RESPONSE.data &&
          RESPONSE.data.data &&
          RESPONSE.data.data.option
        ) {
          this.listData = RESPONSE.data.data.option;
        }
        if (
          RESPONSE &&
          RESPONSE.data &&
          RESPONSE.data.data &&
          RESPONSE.data.data.keyLista
        ) {
          this.keyList = RESPONSE.data.data.keyLista;
        }
        if (this.listData.length > 1) {
          this.disabledbtnDeleted = false;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.$store.dispatch("setCargando", false);
      }
    },
  },
};
</script>

<style lang="scss" scoped src="./Listas.scss">
</style>


// WEBPACK FOOTER //
// src/components/Listas/Listas.vue